import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { LevelModel } from 'src/app/models/supplier-score.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';

@Component({
    selector: 'app-level-modal',
    templateUrl: './level-modal.component.html',
    styleUrls: ['./level-modal.component.scss'],
    imports: [FormsModule, ColorPickerModule]
})
export class LevelModalComponent {
  toastr = inject(ToastService);
  supplierSvc = inject(SupplierService);

  @Output() closeModal = new EventEmitter<void>();
  @Input() selectedlevel?: LevelModel;
  @Output() reloadPage = new EventEmitter<void>();
  newLevel!: LevelModel;

  name: string = '';
  color: string = '#ffffff';
  isVisible: boolean = false;
  requiredPoints: number | null = null;
  isActive: boolean = true;

  ngOnInit() {
    if (this.selectedlevel) {
      this.name = this.selectedlevel.name;
      this.requiredPoints = this.selectedlevel.requiredPoints;
      this.color = this.selectedlevel.color ?? '#ffffff';
      this.isVisible = this.selectedlevel.isVisible;
    }
  }

  onSubmit() {
    if (!this.selectedlevel) {
      if (this.validateForm()) {
        this.supplierSvc.postLevel(this.newLevel).subscribe({
          next: (result) => {
            this.toastr.success(
              'Nivel registrado',
              'El nivel ' +
                this.newLevel.name +
                ' se ha registrado correctamente.'
            );
            this.clearForm();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo registrar el nivel. Todos los campos son obligatorios. ' +
                err.error.error
            );
            this.clearForm();
          },
        });
      }
    } else {
      if (this.validateForm() && this.requiredPoints != null) {
        this.selectedlevel = {
          id: this.selectedlevel.id,
          name: this.name,
          isActive: this.isActive,
          color: this.color,
          isVisible: this.isVisible,
          requiredPoints: this.requiredPoints,
          levelBenefits: [],
        };
      }
      this.supplierSvc
        .patchLevel(this.selectedlevel.id, this.selectedlevel)
        .subscribe({
          next: (result) => {
            this.toastr.success(
              'Nivel editado',
              'El nivel ' + this.newLevel.name + ' se ha editado correctamente.'
            );
            this.clearForm();
          },
          error: (err) => {
            this.toastr.error(
              'Error',
              'No se pudo editar el nivel.' + err.error.error
            );
            this.clearForm();
          },
        });
    }
  }

  clearForm() {
    this.name = '';
    this.requiredPoints = 0;
    this.cancelClick();
  }

  validateForm() {
    if (this.name != '' && this.requiredPoints != null) {
      this.newLevel = {
        id: '',
        name: this.name,
        isActive: this.isActive,
        color: this.color,
        isVisible: this.isVisible,
        requiredPoints: this.requiredPoints,
        levelBenefits: [],
      };
      return true;
    } else {
      this.toastr.error(
        'Error',
        'No se pudo registrar el nivel. Todos los campos son obligatorios.'
      );
      return false;
    }
  }

  cancelClick() {
    this.closeModal.emit();
    this.reloadPage.emit();
  }

  validateOnlyNumbers(event: KeyboardEvent) {
    let key = event.key;
    if (['.', 'e', 'E', ',', '-', '+'].includes(key)) {
      event.preventDefault();
    }
  }

  validateMax(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 8) {
      input.value = value.slice(0, 8);
    }
  }

  validateName(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    input.value = value.replaceAll(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
  }
}
